exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.radio-no-label-margin[data-v-c8fa4682] .v-label {\n  margin: 0 !important;\n}\n", ""]);

// exports
